import React, {useCallback} from 'react';
import {Link} from 'react-router-dom';

import {typedObserver} from '_/utilities/typed-observer';

import {Props as ItemProps} from './Item';
import ListSection from './Section';
import {Item} from './actions';

/**
 * @deprecated
 */
function ItemWrapperComponent<
  TItemType extends Item<TItemType> = Item<object>,
  TStaticPropsType extends object = object,
  TSectionProps extends {id: string} = {id: string},
>({
  highlight,
  item,
  id,
  index,
  ItemComponent,
  ref,
  renderSection,
  sectionComponents,
  sectionRef,
  staticProps,
  ...props
}: ItemProps<TItemType> & {
  highlight?: string;
  index: number;
  ItemComponent: React.FunctionComponent<ItemProps<TItemType>>;
  renderSection: boolean;
  sectionComponents:
    | Record<string | number, React.FunctionComponent<TSectionProps>>
    | undefined;
  sectionRef?: React.Ref<HTMLDivElement>;
  staticProps?: TStaticPropsType;
}): React.ReactElement {
  const handleClickCapture = useCallback((event: React.MouseEvent) => {
    if (event.button !== 0 || event.metaKey) {
      event.stopPropagation();
    }
    if (event.button === 0 && !event.metaKey) {
      event.preventDefault();
    }
  }, []);

  const sectionId = item.section
    ? typeof item.section === 'string' || typeof item.section === 'number'
      ? item.section
      : item.section.id
    : null;
  const section =
    sectionId && sectionComponents?.[sectionId]
      ? sectionComponents[sectionId]!
      : typeof sectionId === 'string'
        ? sectionId
        : '';
  const SectionComponent = section;
  const sectionProps =
    typeof item.section === 'string' || typeof item.section === 'number'
      ? {}
      : item.section;

  return (
    <>
      {item.section && renderSection ? (
        typeof section === 'string' ? (
          <ListSection
            key={`section:${item.id}`}
            aria-label={section}
            header={section}
            title={section}
          />
        ) : (
          <SectionComponent
            key={`section:${item.id}`}
            ref={sectionRef}
            {...(sectionProps as TSectionProps)}
          />
        )
      ) : null}
      {item.url ? (
        <Link
          data-id={id}
          tabIndex={-1}
          to={item.url}
          onClickCapture={handleClickCapture}
        >
          <ItemComponent
            ref={ref}
            highlight={highlight}
            item={item}
            {...staticProps}
            {...props}
          />
        </Link>
      ) : (
        <ItemComponent
          ref={ref}
          data-id={id}
          highlight={highlight}
          index={index}
          item={item}
          {...staticProps}
          {...props}
        />
      )}
    </>
  );
}

/** @deprecated Use EList instead */
export default typedObserver(ItemWrapperComponent);
